<template>
	<div class="bar-container display-flex flex-row flex-align-center flex-justify-space-between width-100">
		<div class="display-flex flex-row flex-align-center height-100">
			<div class="py-1 height-100">
				<ProjectSelector
					:featureType="featureType"
					:serviceSlug="serviceSlug"
					:isChooseProject="isProjectsHome"
					:serviceWorkspaceId="serviceWorkspaceId"
				/>
			</div>
			<ManageAndCreateTabs :hideTabs="isProjectsHome" class="pl-6" />
		</div>
		<TopBarProjectDetails />
	</div>
</template>

<script>
import ProjectSelector from '@/views/AppLayout/ManageAndCreate/ProjectSelector.vue';
import ManageAndCreateTabs from '@/views/AppLayout/ManageAndCreate/ManageAndCreateTabs.vue';
import TopBarProjectDetails from '@/views/AppLayout/ManageAndCreate/TopBarProjectDetails.vue';
export default {
	name: 'ManageAndCreateTopBar',
	props: {
		featureType: { type: String },
		serviceSlug: { type: String },
		serviceWorkspaceId: { type: String },
	},
	components: {
		ProjectSelector,
		ManageAndCreateTabs,
		TopBarProjectDetails,
	},

	computed: {
		isProjectsHome() {
			return this.$route.meta?.isProjectsHome;
		},
	},
};
</script>
<style scoped lang="scss">
.bar-container {
	height: 70px;
	padding-right: 50px;
	background: var(--bg-color);
	border-bottom: 1px solid var(--tertiary-border-color);
}
</style>
